export default __webpack_public_path__ + "static/media/taco.705b23ab.png";